module.exports = __webpack_public_path__ + "img/triangle.2141432c.svg";